import { BaseEntity } from "./BaseEntity";

export class QrcodeLogoEntity extends BaseEntity {
	constructor() {
		super();
		this.entityName = "Logo";
		this.pageTitle = "Logo";
		this.APIRoute = "Resources/QRCode";
		this.baseEndPoint = "qrcode-logo";
		this.endpoints = {
			list: `${this.baseEndPoint}`,
			create: `${this.baseEndPoint}`,
			get: `${this.baseEndPoint}/:id`,
			delete: `${this.baseEndPoint}/:id`,
			activate: `${this.baseEndPoint}/:id/activate`,
			deactivate: `${this.baseEndPoint}/:id/deactivate`
		};

		this.fields = [
			{ key: 'name', label: 'common.labels.name', type: 'text', visible: true, required: true, editable: true, cols: 6, path: 'name' },
			// imagem será tratada fora do EntityForm (upload)
		];

		this.tableColumns = [
			{ key: 'name', label: 'common.labels.name', visible: true, orderBy: true },
			{ key: 'actions', label: 'common.labels.actions', visible: true, orderBy: false },
		];

		this.pages = {
			edit: { 
				pageTitle: 'Editar Logo',
				pathI18n: `components.qrcode.index.quickAccess/Logos`,  
				route: ['/qrcode', '/qrcode/logos', '/qrcode/logos/edit/:id'] },
			create: {
				pageTitle: 'Criar Logo',
				pathI18n: `components.qrcode.index.quickAccess/Logos`, 
				route: ['/qrcode', '/qrcode/logos', '/qrcode/logos/create'] 
			},
			list: { 
				pageTitle: 'Logos', 
				pathI18n: `components.qrcode.index.quickAccess`,
				route: ['/qrcode', '/qrcode/logos'],
				filters: { quickSearch: { info: 'common.messages.info.searchByName', searchBy: ['name'], type: 'text' } } 
			},
		};
	}
}

